import {
  ApplicationQuestion,
  CommonQuestionKeys,
  FieldType,
  TextInputType,
} from '@bybeam/platform-types';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

const newQuestions: { [key: string]: ApplicationQuestion } = {
  studentZip: {
    key: CommonQuestionKeys.ZIP_CODE,
    copy: { title: 'Please share the zip-code or codes of where you usually reside.' },
    fields: [
      {
        type: FieldType.Text,
        inputType: TextInputType.Text,
        copy: 'Zip-code or codes',
        key: CommonQuestionKeys.ZIP_CODE,
      },
    ],
  },
  receivedBenefits: {
    key: 'receivedBenefits',
    copy: { title: 'Are you currently receiving any of the following?' },
    fields: [
      {
        type: FieldType.CheckboxGroup,
        key: 'receivedBenefits',
        options: [
          { value: 'pell-grant', label: 'Pell Grant' },
          { value: 'snap', label: 'Supplemental Nutrition Assistance Program (SNAP)' },
          { value: 'wic', label: 'TANF/OWF- Cash Assistance' },
          { value: 'federal-work-study', label: 'Federal Work Study' },
          { value: 'other', label: 'Other public benefit (Federal, state, or local)' },
          { value: 'none', label: 'None of the above' },
        ],
      },
    ],
  },
};

const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');

// Add zip code question to the end of the Student Info question group
const studentInfoQuestionGroup = personalInfoSection.questionGroups.find(
  ({ key }) => key === 'studentInfo',
);
studentInfoQuestionGroup.questions.push(newQuestions.studentZip);

// Add benefits received question to Personal Info question group, after the FAFSA question
const personalInfoQuestionGroup = personalInfoSection.questionGroups.find(
  ({ key }) => key === 'personalInfo',
);
const filedFafsaIndex = personalInfoQuestionGroup.questions.findIndex(
  (question) => question.key === 'filedFafsa',
);
personalInfoQuestionGroup.questions.splice(filedFafsaIndex, 0, newQuestions.receivedBenefits);

// Update copy of document section to remove required language, and make the question skippable
CONFIG.sections[CONFIG.sections.findIndex(({ key }) => key === 'documents')] =
  CONFIG.definitions.sections.optionalDocumentation;

export default CONFIG;
